// @flow
export const StopEnum = Object.freeze({"PICKUP": 0, "DROPOFF": 1});
export type StopType = $Values<typeof StopEnum>;
export const LatLngEnum = Object.freeze({"CENTER_ONLY": 0, "FORCE_POLYGON": 1, "FORCE_EXACT": 2});
export type LatLngType = $Values<typeof LatLngEnum>;
export const RideStatus = Object.freeze({
    "ACCEPTED": 1,
    "BOARDED": 2,
    "CANCELLED": 3,
    "NO_SHOW": 4,
    "FINISHED": 5,
    "FEEDBACK": 6
});
export type RideStatusType = $Values<typeof RideStatus>;


export const ServerRideStatus = Object.freeze({
    "ACCEPTED": "ACCEPTED",
    "BOARDED": "BOARDED",
    "CANCELED": "CANCELED",
    "FINISHED": "FINISHED",
    "NO_SHOW": "NO_SHOW",
    "FEEDBACK": "FEEDBACK",
});

export type ServerRideStatusType = $Values<typeof ServerRideStatus>;

export const ServerProposalStatus = Object.freeze({
    "ACCEPTED": "ACCEPTED",
    "SEARCHING_FOR_DRIVER": "SEARCHING_FOR_DRIVER",
    "REJECTED": "REJECTED",
});
export type ServerProposalStatusType = $Values<typeof ServerProposalStatus>;

export type Metadata = {
    key: string,
    value: mixed
}

export type MetadataObj = {
    [key: string]: Metadata | MetadataObj
}

export type EmptyObject = { [any]: empty };

export const isTouchingElement = function (element: Element, x: number, y: number): boolean {
    const {top, left, right, bottom} = element.getBoundingClientRect();
    return (x >= left && x <= right && y >= top && y <= bottom);
};

/**
 * Get the parameters from a URL with a query format
 * google.com/?hello=world&arnold=llane => {"hello": "world", "arnold": "llane"}
 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @param  {String} string The URL
 * @return {Object}     The URL parameters
 */
export const getParamsFromString = (string: string): Object => {
    let params = {};
    let parser = document.createElement("a");
    parser.href = string;
    let query = parser.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};


const getCurrentUrl = (): string => {
    if (navigator.userAgent.match(/Android/i)) {
        return document.location.toString();
    } else {
        return window.location.href;
    }
};

/**
 * referenced from:
 * https://gomakethings.com/getting-all-query-string-values-from-a-url-with-vanilla-js/
 * @returns {Object}
 */
export const getAllQueryParams = (): Object => {
    return getParamsFromString(getCurrentUrl());
};

export const FPS = 30;
export const millisecondsPerFrame = 1000 / FPS;

export const registerCurrentTimeUpdates = (handler: (timestamp: number) => void) => {
    setInterval(() => {
        handler(Date.now());
    }, FPS);
};

export const isUndefined = (obj: any): boolean => typeof obj === "undefined";

export const getMobileOperatingSystemName = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
};

//

/*
    Extract the return type of a function
    usage:
        type ReturnValue = ExtractReturn<typeof setName>
 */
type _ExtractReturn<B, F: (...args: any[]) => B> = B; // eslint-disable-line no-unused-vars
export type ExtractReturn<F> = _ExtractReturn<*, F>;

export const sleep = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));



// WEBPACK FOOTER //
// ./src/Utils/AppUtils.js